// Types TypeScript pour les objets retournés par l'API REST de GLPI.
// Référence : https://github.com/glpi-project/glpi/blob/main/apirest.md

// --- Valeurs numériques connues de GLPI (codes métier) ---

/** Type d'un ticket : 1 = Incident, 2 = Demande. */
export type TicketType = 1 | 2;

/** Statut d'un ticket. 1=Nouveau, 2=Attribué, 3=Planifié, 4=En attente, 5=Résolu, 6=Clos. */
export type TicketStatus = 1 | 2 | 3 | 4 | 5 | 6;

/** État d'une tâche de ticket : 0=aucun, 1=à faire, 2=fait. */
export type TaskState = 0 | 1 | 2;

// --- Entités GLPI ---

export interface GlpiEntity {
  id: number;
  name: string;
  completename?: string;
  comment?: string;
}

export interface GlpiCategory {
  id: number;
  name: string;
  completename?: string;
  entities_id?: number;
  is_recursive?: number;
}

export interface GlpiUser {
  id: number;
  name: string;                 // login
  realname?: string;            // nom de famille
  firstname?: string;           // prénom
  /** Échec pour searchText sur certains champs ; rempli si expand_dropdowns + GET /User/{id}. */
  email?: string;
}

export interface GlpiProfileUser {
  id: number;
  users_id: number;
  profiles_id: number;
  entities_id: number;
  is_recursive?: number;
}

/**
 * Une ligne renvoyée par /search/Ticket.
 * GLPI renvoie un objet dont les clés sont les IDs numériques des champs demandés
 * via `forcedisplay`. Cf. https://glpi-project.org/.
 *
 * Champs habituels :
 *  - 1  = name (titre)
 *  - 2  = id
 *  - 12 = status
 *  - 7  = itilcategory
 *  - 80 = entity name
 */
export interface GlpiTicketSearchRow {
  [fieldId: string]: string | number;
}

export interface GlpiTicketSearchResponse {
  totalcount: number;
  count: number;
  sort: number;
  order: "ASC" | "DESC";
  data: GlpiTicketSearchRow[];
}

// --- Payloads de création ---

export interface CreateTicketPayload {
  name: string;
  content: string;
  entities_id: number;
  type: TicketType;
  itilcategories_id?: number;
  _users_id_requester?: number | number[];
  _users_id_assign?: number;
  status: TicketStatus;
}

export interface CreateTicketTaskPayload {
  tickets_id: number;
  content: string;
  /** Format attendu par GLPI : YYYY-MM-DD HH:mm:ss */
  date: string;
  /** Durée en secondes (0 si vide). */
  actiontime: number;
  users_id_tech?: number;
  taskcategories_id?: number;
  state: TaskState;
}

export interface CreateTicketFollowupPayload {
  items_id: number;
  itemtype: "Ticket";
  content: string;
  is_private: 0 | 1;
}

// --- Réponses ---

export interface CreatedRecord {
  id: number;
  message?: string;
}

// --- Erreur GLPI ---

/**
 * GLPI renvoie souvent un tableau [code, message] en cas d'erreur :
 * ["ERROR_GLPI_LOGIN_USER_TOKEN", "paramètres incorrects"]
 */
export type GlpiErrorPayload = [string, string] | { message?: string };

export class GlpiError extends Error {
  public code: string;
  public httpStatus?: number;

  constructor(code: string, message: string, httpStatus?: number) {
    super(message);
    this.name = "GlpiError";
    this.code = code;
    this.httpStatus = httpStatus;
  }
}
